import { render } from "./BrandsSignup.vue?vue&type=template&id=331d1259"
import script from "./BrandsSignup.vue?vue&type=script&lang=js"
export * from "./BrandsSignup.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__